export enum CourseResourceType {
  coursewareAndLab = 0, // 课件和实验
  courseware = 1, // 课件
  question = 2, // 课题
  live = 3, // 直播课
  lab = 4 // 实验
}

export enum CoursePublishStatus {
  publish = 1,
  unPublish = 2
}

export enum CoursewareResourceType {
  video = 1,
  ppt = 2,
  pdf = 3
}

export enum CourseLabType {
  ai = "AI",
  bg = "BIGDATA",
  kp = "HWCLOUD",
  iot = "IOT",
  iot_industry = "IOT_INDUSTRY",
  iot_5g = "IOT_5G"
}

export enum CourseType {
  // 专业课
  special = 1,
  // 直播课
  live = 2
}

export enum Range {
  mine = "mine",
  all = "all"
}

export enum MessageType {
  all = "",
  system = 1,
  questionAnswer = 2,
  report = 3
}

export enum LabLayout {
  ManualPDF = 1,
  ManualMarkdown = 2,
  VideoMp4 = 3,
  VideoAvi = 4,
  MaterialPDF = 5,
  MaterialZip = 6,
  MaterialRar = 7,
  MaterialJar = 8,
  Material7z = 9
}

export enum MaterialType {
  mp4 = 1,
  avi = 2,
  pdf = 3,
  md = 4,
  zip = 5,
  rar = 6,
  jar = 7,
  sevenZ
}

export enum MessageScope {
  user = 3
}
